
import PlantList from "@/components/plant/PlantList.vue"

export default {
  name: 'PlantListPage',
  components: {PlantList}
}
